// initial state
const state = {
  apiURL: "https://localhost:8843/commerce-api/v1/",
  isUserLoggedIn: window.heb.data.user.isLoggedIn, // hot user
  isUserRecognized: window.heb.data.user.isRecognized, // warm user
  isUserCold: window.heb.data.user.isGuest, // cold user
  taxExemptionStatus: window.heb.data.user.taxExemptionStatus,
  orderContext: window.heb.data.user.orderContext,
  screen: window.heb.screen,
  showCartSwitchModal: window.heb.data.user.showCartSwitchModal,
  constants: {
    UI_MAX_ORDER_QUANTITY: 99, // Maximum number that the UI can display
    ERROR_MAX_ORDER_QUANTITY: "Quantity limit reached",
  }
};

const getters = {
};

const actions = {
};

const mutations = {
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
